export default "__VITE_ASSET__8_t_fIUe__"